export default "__VITE_ASSET__DtVORMC1__"